import { FileText, Music2, Image, AudioLines, Video, File, Link2 } from "lucide-react";
import api, { API, withToken } from "@/lib/api";
import MediaPlayer from "@/components/MediaPlayer";

export const RESOURCE_ICONS = {
  pdf: FileText,
  score: Music2,
  image: Image,
  audio: AudioLines,
  video: Video,
  document: File,
  link: Link2,
};

export const isMediaResource = (r) => r.type === "audio" || r.type === "video";

// URL de streaming authentifiée par query token (balises <audio>/<video> sans en-têtes)
export const teachingFileUrl = (id) => withToken(`${API}/teaching/resources/${id}/file`);

// Lecteur média pédagogique : même moteur que l'espace Groupe (vitesse, boucle A-B, plein écran),
// sans les fonctions liées aux fichiers de groupe (repères, renommage, transcodage)
export function ResourcePlayerDialog({ resource, onClose }) {
  if (!resource) return null;
  return (
    <MediaPlayer
      file={{ id: resource.id, kind: resource.type, name: resource.title }}
      srcOverride={teachingFileUrl(resource.id)}
      downloadOverride={teachingFileUrl(resource.id)}
      features={{ markers: false, rename: false, processing: false }}
      onClose={onClose}
    />
  );
}

// Ouvre une ressource pédagogique : lien externe en nouvel onglet, sinon blob authentifié (§42)
export const openTeachingResource = async (r) => {
  if (r.type === "link") {
    window.open(r.external_url, "_blank", "noopener");
    return;
  }
  const resp = await api.get(`/teaching/resources/${r.id}/file`, { responseType: "blob" });
  const url = URL.createObjectURL(new Blob([resp.data], { type: r.mime || "application/octet-stream" }));
  window.open(url, "_blank");
};
